export default __webpack_public_path__ + "static/media/thiettao.16998e74.png";